module.exports = __webpack_public_path__ + "img/eden_logo.95b492fb.svg";